export default "__VITE_ASSET__CW8kVv9l__"